export function createParams() {
    return {
        id: null, // 若不为空，则为修改
        balance_type: null,
        type: null, // 合同大类
        sub_type: null, // 合同小类
        relation_type: null, // 关联类型 stock: 存货，course：课程，stock_course: 存货和课程，none：无
        need_at_audit: false, // 是否需要分析组审核
        teams: []
    }
}

export function commonValidateRule(text) {
    return (val) => {
        return !['', undefined, null].includes(val) || text
    }
}